export type TabId = 'conversations' | 'tasks' | 'credentials' | 'users' | 'changelog';

export interface NavigationState {
  activeTab: TabId;
  setActiveTab: (tab: TabId) => void;
  activeConversationId: string | null;
  selectConversation: (id: string | null) => void;
}

import { useState } from 'react';

export function useNavigation(): NavigationState {
  const [activeTab, setActiveTab] = useState<TabId>('conversations');
  const [activeConversationId, setActiveConversationId] = useState<string | null>(null);

  return {
    activeTab,
    setActiveTab,
    activeConversationId,
    selectConversation: setActiveConversationId,
  };
}
